import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery, useMutation } from '@apollo/client';
import { TextInput } from '@guildeducationinc/recess';
import { TEST_FILTER } from '@src/graphql/queries/filter';
import { EntityType } from '@src/types';
import _ from 'lodash';
import { FILTERS, FilterBuilder, SAVE_FILTER, TrackableButton, useLocale, } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const PopulationBuilder = ({ clientId, value, onCompleted }) => {
    const { t } = useLocale();
    const [filter, setFilter] = useState(value);
    const [saveFilter] = useMutation(SAVE_FILTER, {
        refetchQueries: [
            { query: FILTERS, variables: { spec: { clientId, returnType: EntityType.EMPLOYEE } } },
        ],
    });
    const [testResult, setTestResult] = useState(null);
    const [testFilterQuery, testFilterResult] = useLazyQuery(TEST_FILTER);
    useEffect(() => {
        if (testFilterResult?.data) {
            setTestResult({
                found: testFilterResult.data.testFilter.found,
                total: testFilterResult.data.testFilter.total,
            });
        }
        if (testFilterResult?.error) {
            setTestResult({
                error: testFilterResult.error.message,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testFilterResult]);
    const handleSave = async () => {
        // validate
        // save
        await saveFilter({
            variables: {
                input: {
                    ..._.omit(filter, ['id', 'createdAt', 'updatedAt', '__typename']),
                    id: filter.id ? filter.id : null,
                },
            },
        });
        onCompleted();
    };
    const handleTest = async () => {
        await testFilterQuery({
            variables: {
                input: {
                    ..._.omit(filter, ['id', 'createdAt', 'updatedAt', '__typename']),
                    id: filter.id ? filter.id : null,
                },
            },
        });
    };
    return (_jsxs("div", { children: [_jsx("div", { className: 'text-3xl', children: t('Population Builder') }), _jsx("div", { className: 'flex gap-1 py-1', children: _jsxs("div", { className: 'grow text-right', children: [testResult && (_jsxs("span", { className: 'font-bold mr-1', children: [!testResult.error && (_jsx("span", { children: t('Found {found} out of {total} employees that matched these conditions', {
                                        values: { found: testResult.found, total: testResult.total },
                                    }) })), testResult.error && (_jsx("span", { className: 'text-red-600', children: t('Error running test. Verify that the conditions are completed and try again') }))] })), _jsx(TrackableButton, { btnType: 'mui', enText: 'Test', tag: 'population', variant: 'outlined', onClick: () => handleTest(), children: t('Test') })] }) }), _jsxs("div", { className: 'flex flex-col gap-3', children: [_jsx(TextInput, { label: '', placeholder: 'Name', value: filter.name, onChange: e => setFilter({ ...filter, name: e.target.value }) }), _jsx(FilterBuilder, { clientId: clientId, entityEnumType: EntityType, criteria: filter.criteria, onChange: value => setFilter({ ...filter, criteria: value }), hideEntityType: true, initialCondition: true, defaultEntityType: EntityType.EMPLOYEE, customizedMessaging: true })] }), _jsxs("div", { className: 'flex flexJustify--space_between mt-4', children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Cancel', tag: 'population', variant: 'outlined', onClick: () => onCompleted(), children: t('Cancel') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Save', tag: 'population', variant: 'contained', onClick: () => handleSave(), children: t('Save') })] })] }));
};
